export default function MobileBurgerMenu() {
	// mobile burger menu
	let burger = document.querySelector( '.burger-button' );
	let menu_body = document.querySelector( '#header-menu' );
	let body = document.querySelector( 'body' );
	if ( !menu_body ) {
		menu_body = document.querySelector( '.header-menu' );
	}
	if ( burger ) {
		burger.onclick = function () {
			menu_body.classList.toggle( 'mobile' );
			burger.classList.toggle( 'mobile' );
			body.classList.toggle( 'mobile' );
		}
	}

	window.onresize = function () {
		if ( window.innerWidth > 767 ) {
			let burger = document.querySelector( '.burger-button' );
			let menu_body = document.querySelector( '#header-menu' );
			let body = document.querySelector( 'body' );
			if ( !menu_body ) {
				menu_body = document.querySelector( '.header-menu' );
			}
			if ( menu_body ) {
				menu_body.classList.remove( 'mobile' );
			}
			if ( burger ) {
				burger.classList.remove( 'mobile' );
			}
			if ( body ) {
				body.classList.remove( 'mobile' );
			}
		}
	}

	const has_sub_menu = document.querySelectorAll( '.has-sub-menu' );
	if ( has_sub_menu ) {
		has_sub_menu.forEach( ( item ) => {
			item.addEventListener( "click", function ( e ) {
				e.stopPropagation();
				item.parentElement.classList.toggle( 'active' );
				item.classList.toggle( 'open' );
			} );
		} );
	}
}